import { i18n } from "@tellescope/i18n";
import { formatDateTime } from "./date-formatters";
import { sanitizeEmailHTMLContent } from "./html/sanitize-email-html-content";

export interface EmailFields {
  subject: string;
  HTMLContent?: string;
  timestamp?: Date;
  cc?: string[];
  destination?: string[];
  alternateToAddress?: string;
  fromEmailOverride?: string;
  scheduledFromEmail?: string;
  source: string;
}

export const renderEmailForForwardedMessage = <T extends EmailFields>({
  subject,
  HTMLContent,
  timestamp,
  cc,
  destination,
  alternateToAddress,
  fromEmailOverride,
  scheduledFromEmail,
  source,
}: T): string => {
  const fromEmail = fromEmailOverride ?? scheduledFromEmail ?? source;
  const toAddresses = [...(destination ?? []), ...(alternateToAddress ? [alternateToAddress] : [])];

  const dateLine = timestamp
    ? `\n  <div><b>${i18n.t("Date:", { ns: "email" })}</b> ${formatDateTime(
        timestamp,
        "ddd, MMM D, YYYY at hh:mm a"
      )}</div>`
    : "";
  const ccLine = cc && cc.length > 0 ? `\n  <div><b>${i18n.t("Cc:", { ns: "email" })}</b> ${cc.join(", ")}</div>` : "";

  return `<br>
<div class="tellescope-forwarded">
  <div>---------- ${i18n.t("Forwarded message", { ns: "email" })} ----------</div>
  <div><b>${i18n.t("From:", { ns: "email" })}</b> ${fromEmail}</div>${dateLine}
  <div><b>${i18n.t("Subject:", { ns: "email" })}</b> ${subject}</div>
  <div><b>${i18n.t("To:", { ns: "email" })}</b> ${toAddresses.join(", ")}</div>${ccLine}
  <br>
  <blockquote style="margin: 0 0 0 .8ex;border-left:1px solid #ccc;padding-left:1ex">
    ${sanitizeEmailHTMLContent(HTMLContent ?? "")}
  </blockquote>
</div>`;
};
